module.exports = __webpack_public_path__ + "static/media/27.85272b8c.jpg";